export const VERSION = {
    buildTime: new Date().toISOString(),
    buildId: Date.now().toString(),
};
